﻿<script>
import { styleState } from '@app/store/styleStore.svelte.js';
import {
    hideModal
} from '@app/store/modalStore.svelte.js';
import * as m from "@app/paraglide/messages.js";

function saveSettings(){
    /* Save settings to local storage */
    localStorage.setItem('cc-display-defaults', JSON.stringify({
        width: styleState.width,
        height: styleState.height,
        xPadding: styleState.xPadding,
        yPadding: styleState.yPadding,
        lineSpacing: styleState.lineSpacing,
        defaultBackgroundColor: styleState.defaultBackgroundColor,
    }));

    hideModal();
}


</script>

<div id="displaySettingsForm" aria-label={m.options_display_form_label()}>
    <div class="alert alert-warning mb-4">
        <h6 class="alert-heading">{m.options_display_grid_system_title()}</h6>
        <p class="mb-0">{m.options_display_grid_system_desc({ width: styleState.width, height: styleState.height })}</p>
    </div>
    
    <h5 class="mb-3">{m.options_display_grid_settings_title()}</h5>
    <div class="row mb-4">
        <div class="col-md-6">
            <label for="displayWidth" class="form-label">{m.options_display_width_label()}</label>
            <input 
                type="number" 
                class="form-control" 
                id="displayWidth" 
                min="1" 
                max="100" 
                onfocus={(e) => {
                    e.target.select()
                }}
                bind:value={styleState.width}
            >
            <div class="form-text">{m.options_display_width_help()}</div>
        </div>
        <div class="col-md-6">
            <label for="displayHeight" class="form-label">{m.options_display_height_label()}</label>
            <input 
                type="number" 
                class="form-control" 
                id="displayHeight" 
                min="1" 
                max="50" 
                onfocus={(e) => {
                    e.target.select()
                }}
                bind:value={styleState.height}
            >
            <div class="form-text">{m.options_display_height_help()}</div>
        </div>
    </div>
    
    <h5 class="mb-3">{m.options_display_formatting_title()}</h5>
    <div class="row mb-4">
        <div class="col-md-3">
            <label for="lineSpacing" class="form-label">{m.options_display_line_spacing_label()}</label>
            <input 
                type="number" 
                class="form-control" 
                id="lineSpacing" 
                min="0" 
                max="10" 
                step="1"
                onfocus={(e) => {
                    e.target.select()
                }}
                bind:value={styleState.lineSpacing}
            >
            <div class="form-text">{m.options_display_line_spacing_help()}</div>
        </div>
        <div class="col-md-3">
            <label for="xPadding" class="form-label">{m.options_display_horizontal_padding_label()}</label>
            <input 
                type="number" 
                class="form-control" 
                id="xPadding" 
                min="0" 
                max="50" 
                step="0.1"
                onfocus={(e) => {
                    e.target.select()
                }}
                bind:value={styleState.xPadding}
            >
            <div class="form-text">{m.options_display_horizontal_padding_help()}</div>
        </div>
        <div class="col-md-3">
            <label for="yPadding" class="form-label">{m.options_display_vertical_padding_label()}</label>
            <input 
                type="number" 
                class="form-control" 
                id="yPadding" 
                min="0" 
                max="50" 
                step="0.1"
                onfocus={(e) => {
                    e.target.select()
                }}
                bind:value={styleState.yPadding}
            >
            <div class="form-text">{m.options_display_vertical_padding_help()}</div>
        </div>
        <div class="col-md-3">
            <label for="defaultBackgroundColor" class="form-label">{m.options_display_default_background_color_label()}</label>
            <select
                class="form-select"
                id="defaultBackgroundColor"
                bind:value={styleState.defaultBackgroundColor}
            >
                <option value="black">{m.options_display_default_background_color_black()}</option>
                <option value="transparent">{m.options_display_default_background_color_transparent()}</option>
            </select>
            <div class="form-text">{m.options_display_default_background_color_help()}</div>
        </div>
    </div>
    <button type="button" class="btn btn-primary" onclick={saveSettings}>{m.options_display_save_settings()}</button>
</div>
